import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b4366c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Tipos de agua")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Luminosidad")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Estimación asociada")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Etiquetado óptico/fisicoquímico")
], -1))

import { ref, onMounted, watch } from "vue";
import { Plus, DataLine } from "@element-plus/icons-vue";
import { ImageLabelData } from "@/types/Image.type.ts";
import { WaterType } from "@/types/waterType.type.ts";
import { useRoute } from "vue-router";
import WaterTypeList from "@/components/waterType/WaterTypeList.component";
import { getWaterTypes } from "@/service/waterType.service.ts";
import imageFqLabel from "@/components/processTracking/imageLabel/imageFQLabel.component.vue";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { getOptions, options_2, convertWaterTypeToOptions } from "@/utils/imageLabel.util.ts";
import { CascadeOption } from "@/types/genericData";

type FormFilter = {
  samplingPoint: SamplingPoint;
  fromDateTime: Date;
  toDateTime: Date;
  numberImageLabel: number;
  type: string;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    image: null,
    updatedLabel: null,
    formFilter: null,
    images: null,
    labels: null,
    notEdit: { type: Boolean }
  },
  emits: ["updateLighting", "updateLabel"],
  setup(__props: any, { emit }: { emit: ({
  (e: "updateLighting", value: string): void;
  (e: "updateLabel", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  image: ImageLabelData;
  updatedLabel: ImageLabelData;
  formFilter: FormFilter;
  images?: Array<ImageLabelData>;
  labels?: Array<ImageLabelData>;
  notEdit: boolean;
}




const route = useRoute();
const typeShow = route.query.type;
const labeRoute = route.path == "/process-tracking/samplingpoints/FQConfig";

const dialogFormVisible = ref(false);

const value1 = ref([]);
const value2 = ref([] as string);
const lighting_condition = ref("");
const label = ref("");
const waterType = ref<WaterType[]>([]);
const options_1 = ref<CascadeOption[]>([]);

/**
 * Añadir una nueva tipología de agua a las opciones
 * @param valor
 * @param listWaterType
 * @returns
 */
const pushWaterType = async (valor: WaterType): CascadeOption[] => {
  waterType.value.push(valor);
  options_1.value = await convertWaterTypeToOptions(waterType.value);
};

/**
 * Actualizar lighting_condition cuando hay un nuevo valor
 */
const handleChangelighting_condition = () => {
  lighting_condition.value = value2.value.join("_");
  //enviamos dato al componente padre
  emit("updateLighting", lighting_condition.value);
};

/**
 * Actualizar label cuando hay un nuevo valor
 */
const handleLabel_condition = () => {
  label.value = value1.value[value1.value.length - 1];
  // enviamos dato al componente padre
  emit("updateLabel", label.value);
};

onMounted(async () => {
  waterType.value = await getWaterTypes(route.query.samplingPoint);
  options_1.value = await convertWaterTypeToOptions(waterType.value);
});

watch(
  () => props.updatedLabel,
  (newVal) => {
    // - change currentPage
    value1.value = [];
    value2.value = [];
    lighting_condition.value = newVal?.imageLabel?.lighting_condition;
    label.value = newVal?.imageLabel?.label;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_card, {
        class: "element-card gray",
        style: {"max-width":"100%"},
        shadow: "never"
      }, {
        header: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { class: "element-row" }, {
            default: _withCtx(() => [
              (__props.image?.imageLabel)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.image.imageLabel?.label ? __props.image.imageLabel?.label : "-"), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (label.value)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(label.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "element-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_cascader, {
                modelValue: value1.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value1).value = $event)),
                options: options_1.value,
                clearable: "",
                "show-all-levels": false,
                disabled: _unref(typeShow) == 'view' || props.notEdit || labeRoute,
                onChange: handleLabel_condition
              }, null, 8, ["modelValue", "options", "disabled"]),
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Plus),
                circle: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogFormVisible.value = true))
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        class: "element-card gray",
        style: {"max-width":"100%"},
        shadow: "never"
      }, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { class: "element-row" }, {
            default: _withCtx(() => [
              _createTextVNode(" Valor asociado:" + _toDisplayString(props.image?.luminosity?.value
            ? `${props.image?.luminosity?.value} (${_ctx.$d(
                new Date(props.image?.luminosity?.date?.toLocaleString()),
                "dateTimeNoSecs"
              ).replace(",", "")})`
            : "-"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "element-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { class: "element-row" }, {
                default: _withCtx(() => [
                  (__props.image?.imageLabel)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "warning"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.image?.imageLabel?.lighting_condition ? __props.image?.imageLabel?.lighting_condition : "-"), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (lighting_condition.value)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(lighting_condition.value), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "element-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_cascader, {
                modelValue: value2.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value2).value = $event)),
                options: _unref(options_2),
                onChange: handleChangelighting_condition,
                disabled: _unref(typeShow) == 'view' || labeRoute || props.notEdit
              }, null, 8, ["modelValue", "options", "disabled"]),
              _createVNode(_component_el_button, {
                icon: _unref(DataLine),
                disabled: true
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        class: "element-card gray",
        shadow: "never"
      }, {
        header: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { class: "element-row" }, {
            default: _withCtx(() => [
              _createTextVNode("Matriz de agua: " + _toDisplayString(props.image?.nameTmoa ? props.image?.nameTmoa : "-"), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        class: "element-card gray",
        shadow: "never"
      }, {
        header: _withCtx(() => [
          _hoisted_5
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { class: "element-row" }, {
            default: _withCtx(() => [
              _createVNode(imageFqLabel, {
                formFilter: __props.formFilter,
                image: __props.image,
                images: __props.images,
                labels: __props.labels
              }, null, 8, ["formFilter", "image", "images", "labels"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (dialogFormVisible.value)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: dialogFormVisible.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogFormVisible).value = $event)),
          title: _ctx.$t('label.waterType'),
          width: "50%"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(WaterTypeList), {
              onUpdateWaterType: pushWaterType,
              list: waterType.value
            }, null, 8, ["list"])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})